import { Popover, Radio } from 'antd'
import { TextLang } from '../../../types'
import { FormattedMessage, useIntl } from 'react-intl'
import { supportLanguageList } from '../../../data/supportLanguage'
const languageList = require('language-list')()
const popOverTitle = (
  <div className="ant-popover-guide-message-title ">
    <FormattedMessage
      id={'Upload.PkgCreation.createPack.packLanguage.guide.title'}
      defaultMessage={'‘No text’ case'}
    />
  </div>
)
const popOverContent = (
  <div style={{ display: 'flex', marginBottom: '4px' }}>
    <img
      src={
        require('../../../img/upload/guide_modal/sticker_thumbnail.png').default
      }
      width={72}
      height={72}
      style={{ border: '1px solid #ddd', borderRadius: 5, marginRight: '12px' }}
      alt="sticker_thumbnail"
    />
    <div className="ant-popover-guide-message-description">
      <div>
        <FormattedMessage
          id={'Upload.PkgCreation.createPack.packLanguage.guide.description.1'}
          defaultMessage={'1. If it consists of images only'}
        />
      </div>
      <div>
        <FormattedMessage
          id={'Upload.PkgCreation.createPack.packLanguage.guide.description.2'}
          defaultMessage={'2. When using special symbols recognized as images'}
        />
      </div>
    </div>
  </div>
)

type SelectLangFormProp = {
  packageTextLang: TextLang
  textLang: TextLang | null
  setTextLang: any
}
export default function SelectLangForm({
  packageTextLang,
  textLang,
  setTextLang,
}: SelectLangFormProp) {
  const intl = useIntl()
  const supportLang = supportLanguageList.find(
    ({ code }) => code === packageTextLang,
  )
  return (
    <div className="select-lang-form-wrapper ">
      <div className={'select-lang-form-container'}>
        <Radio.Group
          value={textLang}
          onChange={(e) => setTextLang(e.target.value)}
        >
          <Popover
            placement="bottomLeft"
            title={popOverTitle}
            content={popOverContent}
            trigger="click"
          >
            <Radio value={'IMAGE_ONLY'} style={{ marginLeft: 16 }}>
              {intl.formatMessage({
                id: 'PackageInfo.package.language.onlyImage',
              })}
            </Radio>
          </Popover>

          {packageTextLang !== 'IMAGE_ONLY' && (
            <Radio value={packageTextLang} style={{ marginLeft: 75 }}>
              <span>
                {intl.formatMessage({
                  id: 'PackageInfo.package.language.withText',
                })}
              </span>
              <span>{`(${supportLang ? supportLang.emoji : '🌏'}`}</span>
              <span style={{ marginLeft: '3px' }}>
                {supportLang
                  ? supportLang.name
                  : languageList.getLanguageName(packageTextLang)}
                )
              </span>
            </Radio>
          )}
        </Radio.Group>
      </div>
      <div></div>
    </div>
  )
}
